import Products_C_0 from './Products_C/Products_C_0'
import Products_C_1 from './Products_C/Products_C_1'
import Products_C_3 from './Products_C/Products_C_3'
import Products_C_4 from './Products_C/Products_C_4'
import Products_C_6 from './Products_C/Products_C_6'
import Products_C_8 from './Products_C/Products_C_8'
import Products_C_9 from './Products_C/Products_C_9'
import Products_C_10 from './Products_C/Products_C_10'
import Products_C_11 from './Products_C/Products_C_11'

const Products_C = [
  Products_C_0,
  Products_C_1,
  null,
  Products_C_3,
  Products_C_4,
  null,
  Products_C_6,
  null,
  Products_C_8,
  Products_C_9,
  Products_C_10,
  Products_C_11
]
export default Products_C



// WEBPACK FOOTER //
// ./src/components/Products_C.js